export default __webpack_public_path__ + "static/media/tracking.52803100.png";